export const colorPalette = {
  primary: {
    lighter: '#D3E1FE',
    light: '#9CBDFD',
    main: '#4F88FC',
    dark: '#033BAD',
    darker: '#040059',
    contrastText: '#FFFFFF',
  },
  secondary: {
    lighter: '#FFC16D',
    light: '#FFA53C',
    main: '#FF8806',
    dark: '#CC6C05',
    darker: '#995004',
    contrastText: '#FFFFFF',
  },

  info: {
    lighter: '#CAEBFD',
    light: '#61ADF3',
    main: '#004AD9',
    dark: '#002C9C',
    darker: '#001768',
    contrastText: '#FFFFFF',
  },
  success: {
    lighter: '#D3FCD2',
    light: '#77ED8B',
    main: '#22C55E',
    dark: '#118D57',
    darker: '#065E49',
    contrastText: '#FFFFFF',
  },
  warning: {
    lighter: '#FFF5CC',
    light: '#FFD666',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: '#1C252E',
  },
  error: {
    lighter: '#FFE9D5',
    light: '#FFAC82',
    main: '#FF5630',
    dark: '#B71D18',
    darker: '#7A0916',
    contrastText: '#FFFFFF',
  },
  hotel: {
    lighter: '#DBC5FF',
    light: '#B284FB',
    main: '#8C4BF6',
    dark: '#572AA0',
    darker: '#321462',
    contrastText: '#FFFFFF',
  },

  white: { main: '#FFFFFF' },
  black: { main: '#000000' },
  grey: {
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#1C252E',
    900: '#141A21',
  },

  text: {
    primary: '#1C252E',
    secondary: '#637381',
    disabled: '#454F5B',
  },

  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    neutral: '#F4F6F8',
  },

  action: {
    active: '#637381',
    hover: 'rgba(145, 158, 171, 0.08)', // #919EAB 8%
    selected: 'rgba(145, 158, 171, 0.16)', // #919EAB 16%
    focus: 'rgba(145, 158, 171, 0.24)', // #919EAB 24%
    disabled: 'rgba(145, 158, 171, 0.8)', // #919EAB 80%
    disabledBackground: 'rgba(145, 158, 171, 0.24)', // #919EAB 24%
  },

  divider: {
    main: 'rgba(145, 158, 171, 0.2)', // #919EAB 20%
  },
};

export const colorPaletteOptions = Object.entries(colorPalette).flatMap(
  ([key, value]) => {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const subKeys = Object.keys(value);
      const options = subKeys.map((subKey) => `${key}.${subKey}`);
      if (key === 'hotel') {
        return [key, ...options];
      }
      return options;
    }
    return key;
  }
);
